export default [
    "😃",
    "😄",
    "😁",
    "😂",
    "😉",
    "😊",
    "😍",
    "😘",
    "😚",
    "😜",
    "😝",
    "😏",
    "😒",
    "😌",
    "😔",
    "😷",
    "🤒",
    "😵",
    "🤠",
    "😎",
    "🤓",
    "😳",
    "😨",
    "😰",
    "😥",
    "😢",
    "😭",
    "😱",
    "😖",
    "😣",
    "😓",
    "😠",
    "👋",
    "👌",
    "✌",
    "👍",
    "👏",
    "🙏",
    "💪",
    "🙇",
    "🐮",
    "🌹",
    "💋",
    "❤",
    "💔",
    "⭐",
    "🎉",
    "🍺",
    "🎁",
]


// WEBPACK FOOTER //
// ./src/api/emoji.js